import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { deleteEventsSuccess } from "../slices/features/postEvents";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteEventSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteEvents,
      baseUrl,
      id
    );

    yield put(deleteEventsSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(deleteEventsSuccess({ statusCode, statusText }));
  }
}

export function* watchDeleteEvents() {
  yield takeLatest(RequestTypes.DELETE_EVENT_REQUEST, deleteEventSaga);
}
